import React, { useState } from "react";
import { EditProjectTextField } from "~/ProjectForm/EditProjectComponents";
import { GroupedFolder, Project, ProjectFolder } from "~/gql/types2";
import { AddFolder } from "./AddFolder";
import styled from "@emotion/styled";
import { CopyToClipboard } from "../CopyToClipboard";
import { InlineIconButton } from "../InlineIconButton";
import { Body2 } from "@material/react-typography";

const TooltipContainer = styled("dd")`
  overflow: visible !important;
  min-width: 0;
  position: relative;
`;

const OverflowEllipsis = styled("div")`
  display: flex !important;
  overflow: hidden;
  max-width: 100%;

  & > * {
    white-space: nowrap;
  }

  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 6px;
  }

  button.mdc-button {
    margin-top: -3px;
  }
`;

const Tooltip = styled(Body2)`
  position: absolute;
  top: 100%;
  left: 0;
  margin: 0;
  color: white;
  background-color: black;
  border-radius: 5px;
  padding: 4px 8px;
  z-index: 10;
`;

type ProjectFolderEditorProps = {
  project?: Project;
};

export const ProjectFolderEditor: React.FC<ProjectFolderEditorProps> = ({
  project,
}) => {
  if (!project || !window.config.featureFlags.projectFolders) {
    return (
      <>
        <dt>Network Path</dt>
        <dd>
          <EditProjectTextField {...{ name: "networkPath" }} />
        </dd>
      </>
    );
  }

  return (
    <>
      {project.projectFolder ? (
        <FolderDisplay folder={project.projectFolder} label={"Project"} />
      ) : project.groupedFolder ? (
        <FolderDisplay folder={project.groupedFolder} label={"Grouped"} />
      ) : (
        <>
          <dt>Folder</dt>
          <dd>
            <span>(none)</span>
            <AddFolder project={project} />
          </dd>
        </>
      )}
    </>
  );
};

type FolderDisplayProps = {
  folder: ProjectFolder | GroupedFolder;
  label: string;
};
const FolderDisplay: React.FC<FolderDisplayProps> = ({ folder, label }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <dt>{label} Folder</dt>
      <TooltipContainer>
        <OverflowEllipsis
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
        >
          <span className="text">{folder.fullPath}</span>
          <span>
            <CopyToClipboard text={folder.fullPath} label="folder path" />
            <InlineIconButton
              href="/project-folders"
              title={`Organize ${label} Folder`}
              icon="edit"
            />
          </span>
          {show && <Tooltip>{folder.fullPath}</Tooltip>}
        </OverflowEllipsis>
      </TooltipContainer>
    </>
  );
};
